import * as React from 'react';
import TableRow from '@material-ui/core/TableRow';

const CustomTableRow = (props) => {
    return <TableRow {...props} />;
};

export { CustomTableRow as TableRow };
